<template>
  <div class="col-lg-6 col-md-12 col-xs-12 px-6">

    <div class="dummy-score-container cl-card" v-if="busy">
      <div class="dummy-header"></div>
      <div class="row dummy-article">
        <div class="col-6">
          <div class="dummy-current-score"></div>
        </div>
        <div class="col-6">
          <div class="dummy-progress-bar"></div>
          <div class="dummy-progress-bar"></div>
        </div>
      </div>
    </div>

    <div class="score-container cl-card" v-else>
      <div class="score-header">
        {{ $t('common.ct_score') }}
        <img src="/static/images/ic-info-outline-black.svg" alt="classting-score" v-b-modal.catScoreGuide>
      </div>
      <div class="row score-article">
        <div class="col-6">
          <div class="current-score">
            <template v-if="currentScore">
              <strong>{{ currentScore || '-' }}</strong>{{ $t('common.score_value') }}
            </template>
            <template v-else>
              {{ $t('proficiency.need_cat') }}
            </template>
          </div>
          <div class="changed-score" v-if="changedScore !== 0 && currentScore">
            <img :src="`/static/images/${changedScoreResource.icon}`" class="icon" alt="changed-score">
            <span v-bind:style="{ 'color': changedScoreResource.color}">{{ Math.abs(changedScore) }}{{ $t('common.score_value') }}</span>
          </div>
        </div>

        <div class="col-6">
          <div class="current-score-container">
            <div class="label">{{ $t('common.me') }}</div>
            <div class="score-progress-bar">
              <progress-bar :value="currentScoreRate" :bgColor="selectedSubjectColor"/>
            </div>
            <div class="value ml-2">
              {{ currentScore || '-' }}{{ $t('common.score_value') }}
            </div>
          </div>
          <div class="average-score-container">
            <div class="label">{{ $t('common.average') }}</div>
            <div class="score-progress-bar">
              <progress-bar :value="averageScoreRate" :bgColor="'#a4a4a4'" />
            </div>
            <div class="value ml-2">
              {{ averageScore || '-' }}{{ $t('common.score_value') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <CatScoreGuide id="catScoreGuide" />

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { map } from 'lodash';

  import CatScoreGuide from '../components/CatScoreGuide';

  export default {
    name: 'cat-score',

    data() {
      return {
        busy: false,
      };
    },

    props: [
      'selectedSubjectId',
      'selectedSubjectColor',
    ],

    components: {
      CatScoreGuide,
    },

    computed: {
      ...mapGetters({
        filterProficiencyHistory: 'getFilterProficiencyHistory',
        catSubjects: 'getCatSubjects',
        currentScore: 'getCurrentScore',
        averageScore: 'getAverageScore',
        averageScoreRate: 'getAverageScoreRate',
        currentScoreRate: 'getCurrentScoreRate',
        changedScore: 'getChangedScore',
        isParentUser: 'isParentUser',
        routeQuery: 'getRouteQuery',
        childProficiencyHistory: 'getChildProficiencyHistory',
        selectedChildId: 'getSelectedChildId',
      }),

      changedScoreResource() {
        if (this.changedScore < 0) {
          return {
            icon: 'ic-info-decrease.svg',
            color: '#448aff',
          };
        }

        return {
          icon: 'ic-info-increase.svg',
          color: '#ff595f',
        };
      },
    },

    methods: {
      ...mapActions([
        'fetchFilterProficiencyHistory',
        'fetchChildProficiencyHistory',
      ]),
    },

    beforeMount() {
      if (!this.isParentUser) {
        this.busy = true;
        Promise.resolve()
          .then(() => (
            this.fetchFilterProficiencyHistory()
              .then(() => (
                map(this.catSubjects, (item) => {
                  const filters = {};
                  filters.subject_id = item.id;
                  return this.fetchFilterProficiencyHistory(filters);
                })
              ))
          ))
          .then(promise => (
            Promise.all(promise)
          ))
          .then(() => {
            this.busy = false;
          });
      }
    },

    watch: {
      selectedSubjectId(selected) {
        if (!this.childProficiencyHistory[selected] && this.isParentUser) {
          const filters = {
            child_id: this.selectedChildId,
          };

          if (selected !== 0) {
            filters.subject_id = this.selectedSubjectId;
          }

          this.busy = true;
          this.fetchChildProficiencyHistory(filters)
            .then(() => {
              this.busy = false;
            });
        }
      },
    },

  };
</script>

<style lang="scss" scoped>
  $dummy-background-color: rgba(0, 0, 0, 0.1);

  .score-container {
    margin: 14px 0px 14px 0px;
    padding: 14px;
    height: 146px;

    .score-header {
      font-size: 18px;
      padding-top: 14px;
      padding-left: 8px;

      img {
        cursor: pointer;
      }
    }

    .score-article {
      padding: 34px 0 12px 0;

      .current-score {
        font-size: 30px;
        display: inline-block;
        padding: 8px;
      }

      .changed-score {
        font-size: 14px;
        display: inline-block;

        .icon {
          vertical-align: initial;
        }
      }

      .current-score-container {
        font-size: 12px;
        white-space: nowrap;
        font-weight: bold;

        .label {
          text-align: left;
          display: inline-block;
          width: 22px;
          color: rgba(0, 0, 0, 0.6);
        }

        .score-progress-bar {
          width: 50%;
          display: inline-block;
        }

        .value {
          display: inline-block;
          color: rgba(0, 0, 0, 0.6);
        }
      }

      .average-score-container {
        font-size: 12px;
        white-space: nowrap;
        font-weight: bold;

        .label {
          text-align: center;
          display: inline-block;
          width: 22px;
          color: rgba(0, 0, 0, 0.4);
        }

        .score-progress-bar {
          width: 50%;
          display: inline-block;
        }

        .value {
          color: rgba(0, 0, 0, 0.4);
          display: inline-block;
        }
      }
    }
  }

  .dummy-score-container {
    margin: 14px 0px 14px 0px;
    padding: 14px;
    height: 146px;

    .dummy-header {
      background-color: $dummy-background-color;
      padding: 8px;
      width: 20%;
    }

    .dummy-article {
      .dummy-current-score {
        background-color: $dummy-background-color;
        width: 60%;
        padding: 8px;
        margin: 8px 0px 8px 0px;
      }

      .dummy-progress-bar {
        width: 50%;
        background-color: $dummy-background-color;
        padding: 8px;
        margin: 8px 0px 8px 0px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// CatScore.vue?8f9152fa